"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var condo_brain_1 = require("condo-brain");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var material_1 = require("@mui/material");
var react_router_dom_1 = require("react-router-dom");
var UserAdmin_1 = __importDefault(require("./UserAdmin"));
var QuestionAdmin_1 = __importDefault(require("./QuestionAdmin"));
var AmenityAdmin_1 = __importDefault(require("./AmenityAdmin"));
var ReservationAdmin_1 = __importDefault(require("./ReservationAdmin"));
var ParkingAdmin_1 = __importDefault(require("./ParkingAdmin"));
var ElevatorBookingAdmin_1 = __importDefault(require("./ElevatorBookingAdmin"));
var useStyles = (0, makeStyles_1.default)(function (theme) { return (0, createStyles_1.default)({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '100%',
        },
    },
    registerButton: {
        backgroundColor: '#f37f30',
        color: 'white',
        marginBottom: '20px',
    },
    demo: {
        backgroundColor: theme.palette.background.paper,
    },
    title: {
        margin: theme.spacing(4, 0, 2),
    },
    center: {
        display: 'flex',
        justifyContent: 'center',
    },
    tab: {
        padding: theme.spacing(1.5),
        fontSize: theme.typography.pxToRem(15),
    },
}); });
function TabPanel(props) {
    var children = props.children, value = props.value, index = props.index;
    var admin = new condo_brain_1.AdminManager();
    var navigate = (0, react_router_dom_1.useNavigate)();
    if (!admin) {
        navigate('/');
    }
    return (react_1.default.createElement("div", { role: "tabpanel", hidden: value !== index, id: "scrollable-auto-tabpanel-".concat(index), "aria-labelledby": "scrollable-auto-tab-".concat(index) }, value === index && (react_1.default.createElement(material_1.Box, { p: 3 }, children))));
}
function Admin(_a) {
    var userManager = _a.userManager;
    var classes = useStyles();
    var _b = react_1.default.useState(1), value = _b[0], setValue = _b[1];
    var admin = new condo_brain_1.AdminManager();
    if (!admin) {
        return (react_1.default.createElement("div", null));
    }
    if (!userManager.isAdmin && !userManager.isParkingAdmin) {
        return (react_1.default.createElement("div", null));
    }
    var handleChange = function (_event, newValue) {
        setValue(newValue);
    };
    return (react_1.default.createElement("div", { className: classes.root },
        userManager.isAdmin && (react_1.default.createElement(material_1.Paper, { square: true },
            react_1.default.createElement("div", { className: classes.center },
                react_1.default.createElement(material_1.Tabs, { value: value, variant: "scrollable", indicatorColor: "primary", textColor: "primary", onChange: handleChange, "aria-label": "scrollable auto admin tabs", scrollButtons: "auto" },
                    react_1.default.createElement(material_1.Tab, { className: classes.tab, label: "Parking" }),
                    react_1.default.createElement(material_1.Tab, { className: classes.tab, label: "Users" }),
                    react_1.default.createElement(material_1.Tab, { className: classes.tab, label: "Elevator Bookings" }),
                    react_1.default.createElement(material_1.Tab, { className: classes.tab, label: "Reservations" }),
                    react_1.default.createElement(material_1.Tab, { className: classes.tab, label: "Amenities" }),
                    react_1.default.createElement(material_1.Tab, { className: classes.tab, label: "Questions" }))),
            react_1.default.createElement(TabPanel, { value: value, index: 0 },
                react_1.default.createElement(ParkingAdmin_1.default, null)),
            react_1.default.createElement(TabPanel, { value: value, index: 1 },
                react_1.default.createElement(UserAdmin_1.default, null)),
            react_1.default.createElement(TabPanel, { value: value, index: 2 },
                react_1.default.createElement(ElevatorBookingAdmin_1.default, null)),
            react_1.default.createElement(TabPanel, { value: value, index: 3 },
                react_1.default.createElement(ReservationAdmin_1.default, null)),
            react_1.default.createElement(TabPanel, { value: value, index: 4 },
                react_1.default.createElement(AmenityAdmin_1.default, null)),
            react_1.default.createElement(TabPanel, { value: value, index: 5 },
                react_1.default.createElement(QuestionAdmin_1.default, null)))),
        !userManager.isAdmin && userManager.isParkingAdmin && (react_1.default.createElement(ParkingAdmin_1.default, null))));
}
exports.default = Admin;
